<app-dropdown
    [options]="options"
    [valueFormControl]="valueFormControl"
    [fieldPlaceholder]="'export-creation.form.selectRecurrency.placeholder' | translate"
></app-dropdown>
